module.exports = __webpack_public_path__ + "img/smarttransyt-text-badge.070e5382.png";